import { useQuery } from '@tanstack/react-query';
import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { TextContentPage } from '@/UI/Website/TextContent/TextContent.page';

export const TextContentLoader = () => {
  const { data, isLoading } = useQuery({ queryKey: ['widget-settings'] });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <TextContentPage data={data! as WidgetSettingsDto} />;
};
